import React from "react";
import { COUNTRIES, isCountryEnabled } from "../../utils/countries";

export default function CountrySelect({
  id,
  name = "country",
  value,
  onChange,
  className = "",
  disabled = false,
  required = false,
}) {
  const handleChange = (event) => {
    if (typeof onChange === "function") {
      onChange(event.target.value, event);
    }
  };

  return (
    <select
      id={id}
      name={name}
      value={value || ""}
      onChange={handleChange}
      className={className}
      disabled={disabled}
      required={required}
    >
      <option value="">Select country</option>
      {COUNTRIES.map((country) => {
        const enabled = isCountryEnabled(country.code);
        return (
          <option
            key={country.code}
            value={country.name}
            disabled={!enabled}
          >
            {country.name}
            {!enabled ? " (coming soon)" : ""}
          </option>
        );
      })}
    </select>
  );
}
